import { trackInternalEvent } from '@rio/tracking'
import { useEffectOnMount } from 'builder/hooks/useEffectOnMount'
import { useI18n } from 'builder/hooks/useI18n'
import generationFailed from 'images/builder/ai-resume/ai_summary_generation_failed.png'
import { Props } from '../types'
import {
  Container,
  GenerationFailedImg,
  Heading,
  Subheading,
  Actions,
  Back,
  TryAgain,
} from './styles'

export const ANALYTICS_LABEL = 'ai_writer_error_screen'

export const GenerationFailed = (props: Props) => {
  const { sectionNameForAnalytics: section, onBackClick, onTryAgainClick } = props
  const { i18n } = useI18n()

  const onBack = () => {
    onBackClick()
    trackInternalEvent('click_back', {
      section,
      label: ANALYTICS_LABEL,
    })
  }

  const onTryAgain = () => {
    onTryAgainClick()
    trackInternalEvent('click_try_again', {
      section,
      label: ANALYTICS_LABEL,
    })
  }

  useEffectOnMount(() => {
    trackInternalEvent('see_ai_writer_error', { section })
  })

  return (
    <Container>
      <GenerationFailedImg src={generationFailed} alt="AI summary generation failed" />
      <Heading>{i18n.t('builder.ai_profile_summary.error.title')}</Heading>
      <Subheading>{i18n.t('builder.ai_profile_summary.error.description')}</Subheading>
      <Actions>
        <Back theme="ghost" onClick={onBack}>
          {i18n.t('builder.ai_profile_summary.error.button.back')}
        </Back>
        <TryAgain onClick={onTryAgain}>
          {i18n.t('builder.ai_profile_summary.error.button.try_again')}
        </TryAgain>
      </Actions>
    </Container>
  )
}
